<template>
  <CarvisInput
    v-bind="$attrs"
    :id="id"
    class="!h-fit"
    input="textarea"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script setup lang="ts">
defineProps<{
  id: string
}>()

defineEmits(['update:modelValue'])
</script>
